export default __webpack_public_path__ + "static/media/alps_dao_homepage.dbff53ed.png";